import { addDocument as createDocumentRequest } from '@/services/documents-service/documents-service';
import {
  CreateDocumentPayload,
  Document,
} from '@/services/documents-service/documents-service.types';
import { openNotification } from '@/utils/notification/notification';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { t } from 'i18next';

export const useCreateDocument = () => {
  const queryClient = useQueryClient();

  const { mutate: createDocument, isPending } = useMutation<
    Document,
    unknown,
    CreateDocumentPayload
  >({
    mutationFn: (data) => createDocumentRequest(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ReactQueryKeys.DOCUMENTS_ALL() });
      openNotification({
        message: t('documents:notifications.created'),
        type: 'success',
      });
    },
    // The navigate away rides on onSuccess, so a rejected create would otherwise say nothing.
    onError: () => {
      openNotification({
        message: t('documents:notifications.error'),
        type: 'error',
      });
    },
  });

  return { createDocument, isPending };
};
